'use client';

import { useEffect } from 'react';
import { localeDirection, type Locale } from '@/src/i18n/config';

// Keeps <html lang/dir> in sync with the page locale. The root layout can
// only render lang="en" (it sits above the [locale] segment and cannot read
// the param without forcing every page dynamic), and React re-asserts that
// server value during hydration - wiping the pre-paint script's fix. Effects
// run after hydration, so this one wins, and it re-runs on client-side
// navigation between locales. The pre-paint script in app/layout.tsx covers
// the window before hydration; keep the two in agreement via i18n/config.
export function LocaleHtmlAttributes({ locale }: { readonly locale: Locale }) {
  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dir = localeDirection(locale);
  }, [locale]);

  return null;
}
